import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { upcomingContainersApi } from '../api/upcomingContainers.api';
import type { UpcomingContainerRow } from '../interfaces/upcomingContainers.interface';

interface UseUpcomingContainersResult {
  data: UpcomingContainerRow[] | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refresh: () => void;
}

export function useUpcomingContainers(): UseUpcomingContainersResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<UpcomingContainerRow[]>({
    queryKey: ['dashboard', 'upcoming-containers', selectedCompanyId, direction],
    queryFn: () => upcomingContainersApi.get(companyId, direction),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
    refresh: () => {
      void query.refetch();
    },
  };
}
